<template>

  <div :class="['q-card-detail',{ 'embedded': isEmbedded }]">
    <div  :class="['has-text-centered q-card-title',{ 'embedded': isEmbedded }]">
      <img class="service-unit-icon" :src="require(`@/assets/img/${serviceUnitIcon}`)" />&ensp;
      <span class="has-text-centered" :style="{fontSize:qTypeFont}">
        {{ qType }}
      </span>
    </div>
    <div class="flex justify-center align-center">
      <q-number :q-number="qNumber"
                :q-prefix="qPrefix"
                :q-suffix="qSuffix"
                color="#01796f"
                :font-size="qNumberFont">
      </q-number>
      <img v-if="movementPicture" class="movement-icon" :src="require(`@/assets/img/${movementPicture}`)" />
    </div>
    <div v-if="serviceType === 'examination'"
         class="q-card-table" :style="{fontSize:detailFont}">
      <div v-for="row in examinationTables"
           :key="row.name"
           class="columns is-mobile">
        <div class="column is-3 is-offset-1 q-card-topic">
          <span class="col-name" :style="{fontSize:detailFont}">{{ row.name }}</span>
        </div>
        <div class="column q-card-topic">
          <span class="col-value" :style="{fontSize:detailFont}">{{ row.value }}</span>
        </div>
      </div>
    </div>
    <div v-else
         class="q-card-table" :style="{fontSize:detailFont}">
      <div v-for="row in queueTables"
           :key="row.name"
           class="columns is-mobile">
        <div class="column is-3 is-offset-1 q-card-topic">
          <span class="col-name" :style="{fontSize:detailFont}">{{ row.name }}</span>
        </div>
        <div class="column q-card-topic">
          <span class="col-value" :style="{fontSize:detailFont}">{{ row.value }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import QNumber from './qNumber'
import moment from 'moment'
const props = {
  qType: {
    type: String,
    required: true
  },
  qSubType: {
    type: String,
    required: false
  },
  qNumber: {
    type: String,
    default: ''
  },
  qPrefix: {
    type: String,
    default: ''
  },
  qSuffix: {
    type: String,
    default: ''
  },
  isPriority: {
    type: Boolean,
    default: false
  },
  appointTime: {
    type: Number,
    required: false
  },
  shiftEndHour: {
    type: Number,
    require: false
  },
  serviceUnitName: {
    type: String,
    default: ''
  },
  serviceType: {
    type: String,
    required: true
  },
  doctorFullName: {
    type: String,
    required: false
  },
  zoneName: {
    type: String,
    default: ''
  },
  roomName: {
    type: String,
    default: ''
  },
  channel: {
    type: String,
    required: false
  },
  movementType: {
    type: String,
    required: false
  },
  qNumberFont: {
    type: String,
    required: false
  },
  qTypeFont: {
    type: String,
    required: false
  },
  detailFont: {
    type: String,
    required: false
  }
}

export default {
  name: 'qCardDetail',
  props,
  components: {
    QNumber
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      examinationTables: [],
      queueTables: [],
      isEmbedded: process.env.VUE_APP_EMBEDDED === 'true'
    }
  },
  computed: {
    serviceUnitIcon () {
      switch (this.serviceType) {
        case 'examination':
          return 'examination.png'
        case 'registration':
          return 'user-edit.png'
        case 'pharmacy':
          return 'medicine.png'
        case 'cashier':
          return 'money.png'
        default:
          return undefined
      }
    },
    movementPicture () {
      switch (this.movementType) {
        case 'wheelChair':
          return 'WheelChair.svg'
        case 'stretcher':
          return 'Stretcher.svg'
        case 'walk':
        default:
          // return 'Walk.svg';
          return ''
      }
    },
    appointTimeShown() {
      if (!this.shiftEndHour) return this.epochToStr(this.appointTime, 'HH:mm')
      let shiftEndTime = moment();
      shiftEndTime.set({hour: this.shiftEndHour, minute: 0, seconda: 0});
      console.log(shiftEndTime)
      return this.appointTime > shiftEndTime ? this.epochToStr(shiftEndTime - 3600000, 'HH:mm') + ' เป็นต้นไป' : this.epochToStr(this.appointTime, 'HH:mm');
    },
  },
  methods: {

    init () {
      if (this.serviceType === 'examination') {
        this.examinationTables = [
          {
            name: 'เวลานัด',
            value: this.appointTimeShown
          },
          {
            name: 'แพทย์',
            value: this.doctorFullName
          },
          {
            name: 'หน่วยตรวจ',
            value: this.serviceUnitName
          },
          {
            name: 'ห้องตรวจ',
            value: `โซน ${this.zoneName} ห้อง ${this.roomName}`
          }
        ]
        if (this.isPriority) {
          this.examinationTables.shift()
        }
      } else {
        this.queueTables = [
          {
            name: 'ประเภทคิว',
            value: this.qSubType || this.qType
          },
          {
            name: 'ช่องบริการ',
            value: this.channel
          },
          {
            name: 'แผนก',
            value: this.serviceUnitName
          }
        ]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .q-card-detail {
    height: auto;
    border-radius: 15px;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.16);

    &.embedded{
        border-radius:40px;
        padding-bottom:10px;

    }
    .q-card-title {
      font-family: 'Mitr', sans-serif;
      background-color: #01796f;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;

      .service-unit-icon {
       height: 100%;
      }
      &.embedded{
        .service-unit-icon{
            width:5% !important
        }
      }
    }

    .movement-icon {
      position: absolute;
      right: 2rem;
      height: 2rem;
      max-width: 2rem;
      }

    .q-card-table {
      padding-top: 12px;
      padding-bottom: 32px;
    }

    .q-card-topic {
      display: flex;
      align-items: center;
      padding: 0.25rem 0.75rem;
    }

    .col-name {
      font-family: 'Mitr', sans-serif;
      font-size: 1rem;
    }

    .col-value {
      font-family: 'Prajad', sans-serif;
      font-weight: bold;
      font-size: 1.125rem;
    }
  }
</style>
